import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';
// import {loadProfile} from './ProfileAction'
export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const REFRESH_ACCESS_TOKEN = '[refresh access token] refresh access token';
export function signupAction(email, password, navigate) {
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data.data);
            runLogoutTimer(
                dispatch,
                7 * 24 * 60 * 60 * 1000,
                navigate,
            );
            dispatch(confirmedSignupAction(response.data.data));
            navigate('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function Logout(navigate, from) {
	localStorage.removeItem('userDetails');
    navigate('/login');
	return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(authData, navigate) {
    return (dispatch) => {
         login(authData)
            .then((response) => { 
                const expiryDate = new Date();
                saveTokenInLocalStorage(response.data.data, {
                    ...response.data.data,  
                    ...{expireDate : expiryDate.setDate(expiryDate.getDate() + 7)}
                });
                runLogoutTimer(
                    dispatch,
                    7 * 24 * 60 * 60 * 1000,
                    navigate,
                );
                dispatch(loginConfirmedAction(response.data.data)); 
                setTimeout(() => {
			        navigate('/dashboard');      
                }, 2000);
                          
            })
            .catch((error) => {
                console.log('errorerrorerrorerror', error)
                const errorMessage = formatError(error.response.data);
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function refreshAccessToken(payload){
    let getLocalData = localStorage.getItem('userDetails')
    if(getLocalData){
        getLocalData = JSON.parse(getLocalData)
        getLocalData.accessToken = payload
        localStorage.setItem('userDetails', JSON.stringify(getLocalData))
    }
    return {
        type: REFRESH_ACCESS_TOKEN,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
